export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/home-floor-ddbbe92a6252ad08424cc86607a7eeac.png";